import { Component, Input } from "@angular/core";

import { DialogModule } from "primeng/dialog";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@Component({
  selector: "app-save-modal",
  standalone: true,
  imports: [DialogModule, ProgressSpinnerModule],
  templateUrl: "./save-modal.component.html",
  styleUrl: "./save-modal.component.scss",
})
export class SaveModalComponent {
  @Input() visible: boolean = false;
}
